import {
    RECORDING_CHUNK_TYPE,
    RECORDING_SIGNAL_ABORT_TYPE,
    RECORDING_SIGNAL_FINISH_TYPE,
} from '@nesso/recording-contracts/recording.commands';

import { webSocketPublisher } from '@/shared/api/web-socket-publisher';
import { sliceBlobToBase64 } from '@/shared/lib/blob-utils';

import { CHUNK_PART_SIZE } from '../config/audio-recording.config';

export const recordingWebsocket = {
    chunk: async (sessionId: string, chunk: Blob, timestamp: number) => {
        const parts = await sliceBlobToBase64(chunk, CHUNK_PART_SIZE);

        for (const part of parts) {
            await webSocketPublisher.publish(RECORDING_CHUNK_TYPE, {
                recordingId: sessionId,
                chunk: part,
                timestamp,
            });
            timestamp += 1; // increment timestamp for each part to maintain order
        }
    },
    finish: async (sessionId: string) => {
        await webSocketPublisher.publish(RECORDING_SIGNAL_FINISH_TYPE, {
            recordingId: sessionId,
        });
    },
    abort: async (sessionId: string) => {
        await webSocketPublisher.publish(RECORDING_SIGNAL_ABORT_TYPE, {
            recordingId: sessionId,
        });
    },
};
